export default __webpack_public_path__ + "static/paypal-a3fd9f2bb67e912bd52be5604df9de5e.png";